const CONTENT_TYPE = {
  JSON: 'application/json',
  Blob: 'application/octet-stream',
  FormData: 'multipart/form-data',
  Stream: 'text/event-stream'
} as const;

const HTTP_HEADERS = {
  ContentType: 'Content-Type',
  Authorization: 'Authorization',
  Accept: 'Accept'
} as const;

const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const;

const HTTP_RESPONSE_STATUS = {
  created: 201,
  badRequest: 400,
  unauthorized: 401,
  notFound: 404,
  expectationFailed: 417,
  tooManyRequests: 429,
  internalServerError: 500
} as const;

const AXIOS_VALIDATION_ERROR = 'ERR_VALIDATION';

export { CONTENT_TYPE, HTTP_HEADERS, HTTP_METHODS, HTTP_RESPONSE_STATUS, AXIOS_VALIDATION_ERROR };
